<template>
  <StructuredData id="schema-faq" :schema="faqSchema" />
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 bold text-start">{{$t('footer.us.faqs')}}</h2>
      </div>
    </div>
    <PreguntasRespuestas
      v-if="faqsInformation?.length > 0"
      :faqs="faqsInformation"/>
  </div>
</template>

<script setup>
  import HomeApiService from '@/services/api/HomeApiService';
  import { ref, computed, onBeforeMount } from 'vue';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useStructuredData } from '@/composables/useStructuredData';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { usePageMeta } from '@/composables/usePageMeta';
  import PreguntasRespuestas from '@/components/common/PreguntasRespuestas.vue';

  const faqsInformation = ref([]);
  const loadingStore = useLoadingStore();
  const { createFAQSchema } = useStructuredData();
  const { webPageSchema } = usePageMeta();
  const initializing = ref(true);

  const faqSchema = computed(() => createFAQSchema(faqsInformation.value));

  async function fetchFaqs() {
    try {
      loadingStore.show();
      faqsInformation.value = await HomeApiService.getFaqs();
    } catch (error) {
      console.error('Error al obtener las FAQs:', error);
      faqsInformation.value = [];
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => {
    fetchFaqs();
  });
</script>

<style scoped>

  .superior {
    padding-top: 7rem;
  }

  @media only screen and (min-width: 962px) {
    .superior {
      padding-top: 15rem;
    }
  }
</style>
